import React from 'react';
import Card from '../../ui/Card';
import Badge from '../../ui/Badge';
import { LocationIcon, MailIcon, GlobeIcon } from '../../ui/Icons';
import facultiesdata from '../../../data/facultiesdata.json';

function FacultyCard({ fac }) {
  return (
    <Card variant="elevated" className="p-5 flex flex-col justify-between gap-3 text-left">
      <div className="space-y-2">
        <h3 className="font-title text-base sm:text-lg font-bold text-acem-primary-dark leading-snug flex items-start gap-2 flex-wrap">
          <span className="bg-acem-primary text-white text-xs px-2 py-0.5 rounded-md font-sans uppercase font-bold tracking-wider">
            {fac.acronyme}
          </span>
          <span>{fac.nom}</span>
        </h3>

        <div className="space-y-1.5 text-xs sm:text-sm text-acem-text/90 pt-1">
          {fac.adresse && (
            <p className="flex items-start gap-2">
              <LocationIcon className="w-4 h-4 text-acem-primary flex-shrink-0 mt-0.5" />
              <span><strong>Adresse :</strong> {fac.adresse}</span>
            </p>
          )}
          {fac.email && (
            <p className="flex items-start gap-2">
              <MailIcon className="w-4 h-4 text-acem-primary flex-shrink-0 mt-0.5" />
              <span>
                <strong>Email :</strong>{' '}
                <a
                  href={`mailto:${fac.email}`}
                  onClick={(e) => {
                    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                      e.preventDefault();
                      window.open(`https://accounts.google.com/AccountChooser?continue=https%3A%2F%2Fmail.google.com%2Fmail%2F%3Fview%3Dcm%26fs%3D1%26to%3D${fac.email}`, '_blank');
                    }
                  }}
                  className="text-acem-primary hover:underline font-medium"
                >
                  {fac.email}
                </a>
              </span>
            </p>
          )}
          {fac.site_web && (
            <p className="flex items-start gap-2">
              <GlobeIcon className="w-4 h-4 text-acem-primary flex-shrink-0 mt-0.5" />
              <span>
                <strong>Site :</strong>{' '}
                <a
                  href={fac.site_web}
                  target="_blank"
                  rel="noreferrer"
                  className="text-acem-primary hover:underline font-medium"
                >
                  {fac.site_web_texte || fac.site_web}
                </a>
              </span>
            </p>
          )}
        </div>
      </div>
    </Card>
  );
}

export default function FacultiesList() {
  const publicUsmba = facultiesdata.filter((f) => f.type === 'Public');
  const otherPublic = facultiesdata.filter((f) => f.type === 'Autre Public');
  const privateFacs = facultiesdata.filter((f) => f.type === 'Privé');

  return (
    <div className="max-w-6xl mx-auto space-y-12 px-4 py-4">
      {/* 1. Établissements Publics USMBA */}
      <section className="space-y-4">
        <div className="border-b border-acem-border pb-3">
          <h2 className="font-title text-xl sm:text-2xl font-bold text-acem-primary-dark">
            Établissements Publics (USMBA)
          </h2>
          <p className="text-sm text-acem-muted">
            Facultés et écoles relevant de l'<strong>Université Sidi Mohamed Ben Abdellah de Fès</strong>.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {publicUsmba.map((fac, idx) => (
            <FacultyCard key={idx} fac={fac} />
          ))}
        </div>
      </section>

      {/* 2. Autres Établissements Publics */}
      {otherPublic.length > 0 && (
        <section className="space-y-4">
          <div className="border-b border-acem-border pb-3">
            <h2 className="font-title text-xl sm:text-2xl font-bold text-acem-primary-dark">
              Autres Établissements Publics
            </h2>
            <p className="text-sm text-acem-muted">
              Instituts nationaux et centres de formation spécialisés situés à Fès hors USMBA.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {otherPublic.map((fac, idx) => (
              <FacultyCard key={idx} fac={fac} />
            ))}
          </div>
        </section>
      )}

      {/* 3. Établissements Privés */}
      {privateFacs.length > 0 && (
        <section className="space-y-4">
          <div className="border-b border-acem-border pb-3">
            <h2 className="font-title text-xl sm:text-2xl font-bold text-acem-primary-dark">
              Établissements Privés
            </h2>
            <p className="text-sm text-acem-muted">
              Universités privées et grandes écoles d'excellence à Fès.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {privateFacs.map((fac, idx) => (
              <FacultyCard key={idx} fac={fac} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
